import React, { forwardRef, useEffect, useRef } from "react";
import * as c from "./button.module.scss";
import classNames from "classnames";
import { Link } from "gatsby";

const Button = forwardRef(
  (
    {
      className,
      size = "medium",
      variant = "full",
      isExternal = false,
      asHtmlButton = false,
      linkTo = "",
      disabled = false,
      children,
      ...props
    },
    ref
  ) => {
    const internalRef = useRef(null);
    const elementRef = ref || (variant === "cursorGradient" ? internalRef : null);

    let Element;
    const linkProps = {};

    if (asHtmlButton) {
      Element = "button";
    } else if (isExternal) {
      Element = "a";
      linkProps.href = linkTo;
      linkProps.target = "_blank";
    } else {
      Element = Link;
      linkProps.to = linkTo;
    }

    const isAnimated = !disabled && variant !== "link" && variant !== "cursorGradient" && variant !== "textgradient";

    const cx = classNames(className, c.button, c[variant], c[size], {
      [c.animated]: isAnimated,
    });

    useEffect(() => {
      if (elementRef && elementRef.current && variant === "cursorGradient") {
        const handleMouseMove = (e) => {
          const target = e.target;
          const rect = target.getBoundingClientRect();
          const x = e.clientX - rect.left;
          elementRef.current.style.setProperty("--buttonx", `${x}px`);
        };
        elementRef.current.style.setProperty("--buttonx", "0px");
        elementRef.current.addEventListener("mousemove", handleMouseMove);
        return () => {
          elementRef.current.removeEventListener("mousemove", handleMouseMove);
        };
      }
    }, [elementRef, variant]);

    return (
      <Element ref={elementRef} className={cx} {...linkProps} {...props}>
        {children}
      </Element>
    );
  }
);

export { Button };
